<template>
	<v-card
		class="chart-card"
		elevation="2"
	>
		<v-card-title
			v-if="title || $slots.title"
			tag="h3"
			class="sr-only"
		>
			<v-icon
				v-if="icon"
				class="chart-card__icon syrenis-black--text"
			>
				{{ icon }}
			</v-icon>
			<slot name="title">
				<span class="chart-card__title">
					{{ title }}
				</span>
			</slot>
		</v-card-title>
		<v-card-text class="chart-card__body">
			<slot />
		</v-card-text>
		<v-card-actions v-if="$slots.actions">
			<slot name="actions" />
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: 'chart-card',
	props: {
		icon: {
			type: String,
			default: null
		},
		title: {
			type: String,
			default: null
		}
	}
}
</script>

<style scoped>
.chart-card {
  display: flex;
  flex-direction: column;
	margin: 4px;
}

.chart-card__icon {
  margin-right: 8px;
	color: var(--v-primary-base);
	font-size: 1.5rem; /* Adjust icon size */
	vertical-align: middle; /* Align icon with text */
}

.chart-card__title {
  font-size: 1.1rem;
  font-weight: 500;
}

.chart-card__body {
  flex-grow: 1; /* Allows the body to take available space */
  overflow-y: auto; /* Add scroll if content overflows */
}
</style>
